<template>
    <body class="ovrflow desk_bckgnd_img_login">
        <Header></Header>
        <div class="college_main_div">
            <b-container class="bv-example-row login_cont_height login_height mob_col_padding">
                <b-row align-h="center" class="dev_lr_margin row_height">
                    <!-- <b-col lg="7" class="mob_col_padding dev_position"> -->
                    <b-col class="xs_col col-sm-8 col-md-6 col-lg-4 mob_col_padding dev_position">
                        <b-container class="brand--logo">
                            <b-row>
                                <b-col cols="2" class="text-center">
                                    <div class="bck-btn">
                                        <b-button type="Back" variant="outline-light" v-on:click="backAction"
                                            ><img src="images/back_blue.png"
                                        /></b-button>
                                    </div>
                                </b-col>
                                <b-col class="mob-display" cols="8" v-if="store.isLogoAvailable">
                                    <div class="text-center"><img :src="store.groupDetail.cssp" alt="" class="logoImg-class" /></div>
                                </b-col>
                                <b-col class="mob-display" cols="8" v-if="!store.isLogoAvailable">
                                    <div class="text-center">
                                        <p class="init-header-title">{{ store.groupDetail.gnm }}</p>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                        <!-- <b-container class="app contentdiv"> -->
                        <b-container class="contentdiv">
                            <b-row row_height justify-content-center>
                                <b-col><p class="title_text">SIGN INTO YOUR ACCOUNT</p></b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <!-- <div class="main_form"> -->
                                    <div>
                                        <b-container>
                                            <div>
                                                <input
                                                    class="inputstyle"
                                                    id="input-1"
                                                    placeholder="Email Address"
                                                    type="email"
                                                    v-model="form.eml"
                                                    autocomplete="off"
                                                    autocorrect="off"
                                                    autocapitalize="off"
                                                    spellcheck="false"
                                                    required
                                                />
                                                <input
                                                    class="inputstyle"
                                                    id="input-2"
                                                    placeholder="Password"
                                                    type="password"
                                                    v-model="form.pwd"
                                                    autocomplete="off"
                                                    autocorrect="off"
                                                    autocapitalize="off"
                                                    spellcheck="false"
                                                    required
                                                />
                                                <span style="margin-left: -20px">
                                                    <img :src="hidePasswordSrc" @click="hideAndShowPassword" />
                                                </span>
                                            </div>
                                            <p class="forgot-password">
                                                <router-link to="/forgot_password" class="router-link-exact-active"
                                                    >Forgot password?</router-link
                                                >
                                            </p>
                                            <div class="register_continue-btn">
                                                <b-button type="login" v-on:click="onLogin" variant="">LOGIN</b-button>
                                                <b-button type="Back" class="desk_display" v-on:click="goHome" variant="">HOME</b-button>
                                                <br /><br />
                                                <label v-if="errorStatus" class="login_errorMessageLabel" id="errorLabel">
                                                    {{ errorMessage }}
                                                </label>
                                            </div>
                                        </b-container>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Footer></Footer>
    </body>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Header from "@/components/header";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            form: {
                eml: "",
                pwd: "",
            },
            store: store,
            errorStatus: false,
            errorMessage: "",
            hidePasswordSrc: "images/hide password_active.png",
            showPasswordSrc: "images/show password.png",
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        };
    },
    methods: {
        onLogin(evt) {
            evt.preventDefault();
            var header = {};
            //     headers: [
            //       {
            //         key: "Content-Type",
            //         value: "application/json",
            //         type: "text",
            //       },
            //     ],
            //   };
            // console.log('LOGIN');

            if (this.form.eml.length > 0 && !this.reg.test(this.form.eml)) {
                this.errorStatus = true;
                this.errorMessage = "Please, enter valid email address";

            } else if (this.form.eml.length > 0 && this.form.pwd.length > 0) {

                if (!this.reg.test(this.form.eml)) {
                    this.errorStatus = true;
                    this.errorMessage = "Please, enter valid email address";
                } else {
                    // console.log("NAVIGATOR", navigator.onLine);

                    if (navigator.onLine) {
                        apiCall
                            .apiServiceCall("Post", "", "/user/login", this.form, header)
                            .then((response) => {
                                if (response.data.status == 1) {
                                    this.store.isLoginError = false;
                                    this.store.sessionID = response.data.data.token;
                                    window.localStorage.setItem("token", response.data.data.token);
                                    this.store.userDetails = response.data.data.user;
                                    this.store.registration.iid = response.data.data.user.iid;
                                    this.store.registration.eml = response.data.data.user.eml;
                                    this.store.registration.mob = response.data.data.user.mob;
                                    this.store.groupDetail.gid = response.data.data.user.gid;
                                    this.store.groupDetail.imgp = response.data.data.user.imgp;

                                    //Setting the App theme based on the response
                                    document.documentElement.style.setProperty(
                                        "--appHeaderBgColor",
                                        response.data.data.group.color[0].priclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--loginBackgroundColor",
                                        response.data.data.group.color[0].secclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--appTitleTxtColor",
                                        response.data.data.group.color[0].btntxtclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--primaryTextColor",
                                        response.data.data.group.color[0].pritxtclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--textColorLight",
                                        response.data.data.group.color[0].sectxtclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--bannerBackgroundColor",
                                        response.data.data.group.color[0].banbgclr
                                    );
                                    document.documentElement.style.setProperty(
                                        "--errorMessageTextColor",
                                        response.data.data.group.color[0].errtxtclr
                                    );

                                    // const data = JSON.stringify(response.data.data.user.iid);
                                    // window.localStorage.setItem("iid", data);
                                    var CryptoJS = require("crypto-js");
                                    var eml = CryptoJS.AES.encrypt(response.data.data.user.eml, "eml").toString();
                                    window.localStorage.setItem("LI3EIB", eml); //Email
                                    var pwd = CryptoJS.AES.encrypt(this.form.pwd, "pwd").toString();
                                    window.localStorage.setItem("QW3F4OV6", pwd); //Password

                                    window.localStorage.setItem("groupID", JSON.stringify(response.data.data.group.grgcd));
                                    //Fetching the logo image from api and storing in local storage
                                    if (response.data.data.group.cssp.length > 0) {
                                        window.localStorage.setItem("logo", JSON.stringify(response.data.data.group.cssp));
                                        this.store.groupDetail.cssp = JSON.parse(window.localStorage.getItem("logo"));
                                        this.store.isLogoAvailable = true;
                                    } else {
                                        window.localStorage.setItem("gnm", JSON.stringify(response.data.data.group.gnm));
                                        this.store.groupDetail.gnm = JSON.parse(window.localStorage.getItem("gnm"));
                                        this.store.isLogoAvailable = false;
                                    }
                                    this.$router.push({ path: "/app-home" });
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = response.data.message;
                                }
                            })
                            .catch((error) => {
                                if (error.response.status == 500) {
                                    this.errorStatus = true;
                                    this.errorMessage = this.serverProblem;
                                } else if (error.response.status == 401) {
                                    setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                } else if (error.response.status == 504) {
                                    this.signout();
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = error.response.data.message;
                                }
                            });
                    } else {
                        this.errorStatus = true;
                        this.errorMessage = this.checkInternetConnection;
                    }
                }
            } else {
                if (this.form.eml.length == 0 && this.form.pwd.length == 0) {
                    this.errorStatus = true;
                    this.errorMessage = "Email and Password cannot be empty";
                } else if (this.form.eml.length == 0) {
                    this.errorStatus = true;
                    this.errorMessage = "Email cannot be empty";
                } else {
                    this.errorStatus = true;
                    this.errorMessage = "Password cannot be empty";
                }
            }
        },

        onReset(evt) {
            evt.preventDefault();
            this.form.userid = "";
            this.form.pwd = "";
            this.invalidDetails = false;
        },
        backAction() {
            this.$router.push({ path: "/home" });
        },
        /* CA-510 - Starts */
        goHome() {
            this.$router.push({ path: "/home" });
        } /* CA-510 - Ends */,
        hideAndShowPassword() {
            if (document.getElementById("input-2").type === "password") {
                this.hidePasswordSrc = this.showPasswordSrc;
                document.getElementById("input-2").type = "text";
            } else {
                this.hidePasswordSrc = "images/hide password_active.png";
                document.getElementById("input-2").type = "password";
            }
        },
    },
    mounted() {
        //ToDO
        if (this.store.isLoginError) {
            this.errorStatus = true;
            this.errorMessage = "Token expired or " + this.store.loginErrorMsg;
        }
        if (
            (this.store.groupDetail.cssp == undefined || this.store.groupDetail.cssp == undefined) &&
            (this.store.groupDetail.gnm == undefined || this.store.groupDetail.gnm == undefined)
        ) {
            this.store.isLogoAvailable = true;
            this.store.groupDetail.cssp = "images/inspire-logo.png";
        } else {
            if (this.store.groupDetail.cssp.length > 0) {
                this.store.isLogoAvailable = true;
            } else {
                this.store.isLogoAvailable = false;
            }
        }
    },
};
</script>
